<template>
    <Card :title="$t('labels.inventory_status')">
        <div class="card-body">
            <InventoryStatusFieldsetGroup v-if="inventoryStatus" :inventory-status="inventoryStatus" />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="light" @click="remove" class="mr-2">
                <span>{{ $t('buttons.delete') }}</span>
            </AppButton>
            <AppButton size="sm" color="teal" @click="update">
                <span>{{ $t('buttons.edit') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import InventoryStatusFieldsetGroup from './fieldsets/InventoryStatusFieldsetGroup.vue';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator.js';
export default {
    name: "EditInventoryStatusPage",
    components: {
        Card, AppButton, InventoryStatusFieldsetGroup
    },
    data() {
        return {
            inventoryStatus: null
        }
    },
    methods: {
        async fetchInventoryStatus() {
            await httpClient.get(`/management/inventory-statuses/${this.$route.params.inventoryStatusUuid}`).then((response) => {
                this.inventoryStatus = response.data.data
            });
        },
        async update() {
            await httpClient.put(`/management/inventory-statuses/${this.inventoryStatus.uuid}`, {
                name: this.inventoryStatus.name,
                color: this.inventoryStatus.color,
                type: this.inventoryStatus.type,
                order: this.inventoryStatus.order
            }).then((response) => {
                this.inventoryStatus = response.data.data
                new MessageNotificator().success(this.$t('alerts.success'));
            });
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.delete_inventory_status'), async () => {
                await httpClient.delete(`/management/inventory-statuses/${this.inventoryStatus.uuid}`).then(() => {
                    this.$router.push({ name: 'IndexInventoryStatusPage' });
                });
            });
        }
    },
    mounted() {
        this.fetchInventoryStatus();
    }
}
</script>
